import { memo, useRef } from "react";
import { Slider } from "../ui/slider";
import { Switch } from "../ui/switch";
import { Upload } from "lucide-react";

const fmt = (v, step) => (step >= 1 ? v : step >= 0.1 ? v.toFixed(1) : step >= 0.01 ? v.toFixed(2) : v.toFixed(3));

export const RangeControl = ({ label, value, min, max, step, onChange, testid }) => (
  <div className="ctl" data-testid={`${testid}-wrap`}>
    <div className="ctl-head"><span>{label}</span><span className="ctl-val" data-testid={`${testid}-value`}>{fmt(value, step)}</span></div>
    <Slider data-testid={testid} value={[value]} min={min} max={max} step={step} onValueChange={([v]) => onChange(v)} className="lab-slider" />
  </div>
);

export const ToggleControl = ({ label, value, onChange, testid }) => (
  <label className="ctl ctl-toggle">
    <span>{label}</span>
    <Switch data-testid={testid} checked={value} onCheckedChange={onChange} className="lab-switch" />
  </label>
);

export const SelectControl = ({ label, value, options, onChange, testid }) => (
  <div className="ctl">
    <div className="ctl-head"><span>{label}</span></div>
    <div className="seg" data-testid={testid}>
      {options.map(([v, l]) => (
        <button key={v} data-testid={`${testid}-${v}`} onClick={() => onChange(v)} className={`seg-btn ${value === v ? "is-on" : ""}`}>{l}</button>
      ))}
    </div>
  </div>
);

export const ActionButton = ({ action, onRun }) => {
  const ref = useRef(null);
  if (action.kind === "file") {
    return (
      <>
        <button className="act-btn act-file" onClick={() => ref.current?.click()} data-testid={`${action.testid}-button`}><Upload size={14} />{action.label}</button>
        <input ref={ref} type="file" accept={action.accept || "image/*"} className="hidden" data-testid={action.testid}
          onChange={(e) => { const f = e.target.files?.[0]; if (f) onRun(action.id, f); e.target.value = ""; }} />
      </>
    );
  }
  return <button className="act-btn" data-testid={action.testid || `action-${action.id}`} onClick={() => onRun(action.id)}>{action.label}</button>;
};

export const ParamControl = memo(function ParamControl({ p, value, onChange }) {
  const testid = p.testid || `param-${p.key}`;
  if (p.type === "range") return <RangeControl label={p.label} value={value} min={p.min} max={p.max} step={p.step} onChange={(v) => onChange(p.key, v)} testid={testid} />;
  if (p.type === "toggle") return <ToggleControl label={p.label} value={value} onChange={(v) => onChange(p.key, v)} testid={testid} />;
  return <SelectControl label={p.label} value={value} options={p.options} onChange={(v) => onChange(p.key, v)} testid={testid} />;
});
